import { LitElement, html, css, unsafeCSS } from "lit-element";

import numberCompTableStyles from "./number-comparison-table.scss";
import { BroadcastTemplateItemModel } from "../../../models/broadcast/broadcastTemplateModel";
import { MetricModel } from "../../../models/broadcast/metricModel";

export default class NumberComparisonTable extends LitElement {
    private _homeMetric: MetricModel;
    private _awayMetric: MetricModel;
    private _templateItem: BroadcastTemplateItemModel;
    private _homeTeamColour: string;
    private _awayTeamColour: string;

    constructor(
        homeMetric: MetricModel,
        awayMetric: MetricModel,
        template: BroadcastTemplateItemModel,
        homeTeamColour: string,
        awayTeamColour: string) {
        super();

        this._homeMetric = homeMetric;
        this._awayMetric = awayMetric;
        this._templateItem = template;

        this._homeTeamColour = homeTeamColour;
        this._awayTeamColour = awayTeamColour;
    }

    async firstUpdated() {
        this.style.setProperty("--home-color", this._homeTeamColour);
        this.style.setProperty("--away-color", this._awayTeamColour);
    }

    createRenderRoot() {
        return this;
    }

    render() {

        if (this._templateItem.hideIfValueEmpty && !this._homeMetric?.value && !this._awayMetric?.value)
            return html``;

        return [
            html`
            <style>
                ${css`${unsafeCSS(numberCompTableStyles)}`}                     
            </style>

            <div class="comparison-row">
                <div class="column">
                    <div class="comparison-value home-team ${this._homeMetric?.value > this._awayMetric?.value ? 'highlight' : ''}"
                         title="${this._templateItem.name}">${this._homeMetric?.value ?? 0}</div>
                </div>
                <div class="column">
                    <div class="heading">${this._templateItem.name}</div>
                </div>
                <div class="column">
                    <div class="comparison-value away-team ${this._awayMetric?.value > this._homeMetric?.value ? 'highlight' : ''}"
                         title="${this._templateItem.name}">${this._awayMetric?.value ?? 0}</div>
                </div>
            </div>`
        ];
    }
}

window.customElements.define('broadcast-live-stats-number-comparison-table', NumberComparisonTable as any);